import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from 'modules/User/Accounts/Accounts.module.scss'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import { Button } from 'gu-ui-kit'

const Connect = () => {
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()
  return (
    <Button
      component={'a'}
      variant={'link'}
      className={styles['accounts__connect-link']}
      href={pathGen(ROUTES.USER_ADMITAD_ATTACH)}
    >
      {t('user::settings.accounts.connect')}
    </Button>
  )
}
Connect.propTypes = {}

export default Connect
